import React from "react";
import Earning from "./Earning";

function InformalReport() {
  return (
    <div>
      <Earning />
    </div>
  );
}

export default InformalReport;
